export const version = 1777985743659;
export default version;
